import React from "react"
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";
import * as S from "./CardProductSelect.Style"
import Button from "../core/Button/Button";

const CardProductSelect = ({ cardContentItem }) => {
    const history = useHistory();

    return (
        <S.CardProductSelectContainer>
            {cardContentItem.map((card, cardIndex) => {
                return (
                    <S.CardProductSelectMainContent key={card[0]?.id ?? cardIndex}>
                        <S.CardProductSelectContent>
                            <S.CardProductSelectTitle>{card.cardTitle}</S.CardProductSelectTitle>
                            <S.CardProductSelectDescription>{card.cardMainDescription}</S.CardProductSelectDescription>
                        </S.CardProductSelectContent>
                        <Button style={{ width: '100%' }} onClick={() => {
                            history.push(card.link); 
                            setTimeout(() => {
                                window.scrollTo({ top: "10px", behavior: "smooth" });
                            }, 10);
                        }} variant="muted-primary">Ver detalhes</Button>
                    </S.CardProductSelectMainContent>
                )
            })
            }
        </S.CardProductSelectContainer>
    )
}

export default CardProductSelect

CardProductSelect.propTypes = {
    cardContentItem: PropTypes.arrayOf(
        PropTypes.shape({
            cardIcon: PropTypes.element.isRequired,
            cardTitle: PropTypes.string.isRequired,
            cardMainDescription: PropTypes.string.isRequired,
            cardSecondDescription: PropTypes.string.isRequired
        })
    ).isRequired
}